import { BookmarkPage, Enum_Bookmark_Category } from '@edwin-group/cj-graphql';

import { ChapterBookmark } from '@/types/types';

import { Card as ChapterCard } from '@/pages/mission/chapter/components/card';
import { useBookmark } from '../../hooks/useBookmark';
import { BookmarkListCard } from '../shared/BookmarkListCard';
import { buildBookmarkFilters } from '../../utils/buildBookmarkFilters';
import { formatTitle } from '../../utils/formatTitle';

interface ChapterBookmarkListCardProps {
  category: Enum_Bookmark_Category;
  page: BookmarkPage;
}

export default function ChapterBookmarkListCard({ category, page }: ChapterBookmarkListCardProps) {
  const filters = buildBookmarkFilters({ category });
  const { data, refetch } = useBookmark<ChapterBookmark>(filters);

  return (
    <BookmarkListCard
      page={page}
      title={formatTitle(category)}
      data={data ?? []}
      showDivider={false}
      renderCard={(chapter: ChapterBookmark, index: number) => (
        <ChapterCard
          index={chapter?.chapterIndex || 0}
          chapterId={chapter?.chapterId || ''}
          missionSlug={chapter?.missionSlug || ''}
          totalChapters={chapter?.missionTotalChapters || 0}
          trait={chapter?.missionTrait || ''}
          chapter={chapter}
          buttonText={page?.openButtonTxt || ''}
          showBookmarkIcon
          key={`chapter-${index}`}
          onRemoveFromBookmark={refetch}
        />
      )}
    />
  );
}
